import React from "react";
import { Instagram, Linkedin, Mail } from "lucide-react";
import { withUtm } from "@/components/thales/utm";
import { useArkemaLang } from "@/components/thales/i18n";
import { trackPostHogEvent } from "@/lib/analytics";

const ThalesFooter = () => {
  const { t, lang } = useArkemaLang();
  const trackContact = (location: string) =>
    trackPostHogEvent("sncf_contact_celia_clicked", {
      page: "sncf-connect",
      location,
      method: "mailto",
      lang,
    });
  return (
    <footer className="bg-white py-4 px-4">
      <div className="max-w-[1126px] mx-auto">
        <div className="flex items-center justify-between gap-4 md:gap-6 border-b border-[rgba(0,0,0,0.1)] pb-4">
          <div>
            <img
              src="/lovable-uploads/sncf-connect-tech-logo.png"
              alt="SNCF Connect & Tech"
              className="h-8 sm:h-10 w-auto object-contain"
            />
          </div>
          <div>
            <img
              src="/lovable-uploads/thales-ecovadis.png"
              alt="Ecovadis"
              className="h-[30px] md:h-[40px] object-contain"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-7 flex-wrap mt-4">
          <div className="flex-1 flex flex-col md:flex-row md:items-center gap-3 md:gap-7 flex-wrap text-xs md:text-sm text-gray-500">
            <span>© SAS NABOO GROUP 2026</span>
            <a href={withUtm("https://www.naboo.app/en-us/terms-of-use")} className="hover:text-gray-700">
              {t("footer.terms")}
            </a>
            <a href={withUtm("https://www.naboo.app/en-us/privacy-policy")} className="hover:text-gray-700">
              {t("footer.cgu")}
            </a>
            <a
              href="mailto:celia.desailly@naboo.app"
              onClick={() => trackContact("footer_links")}
              className="hover:text-gray-700"
            >
              {t("footer.contact")}
            </a>
            <a href="#" className="hover:text-gray-700">
              {t("footer.cookies")}
            </a>
          </div>
          <div className="flex gap-4 mt-2 md:mt-0">
            <a
              href={withUtm("https://www.linkedin.com/company/naboo-app/posts/?feedView=all")}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Linkedin size={20} />
            </a>
            <a
              href={withUtm("https://www.instagram.com/naboo_app/")}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Instagram size={20} />
            </a>
            <a
              href="mailto:celia.desailly@naboo.app"
              onClick={() => trackContact("footer_social")}
              aria-label="Email"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ThalesFooter;
